const ROUTES = {
    base: '/',
    symbol: '/symbol/:symbol',
    spread: '/spread/:spread',
    strategy: '/strategy/:basketId',
    chart: '/chart/:layoutId?',
    optionChain: '/option-chain/:exchange?/:symbol?',
    strategyBuilder: '/strategy-builder/:exchange?/:symbol?',
    openInterestChange: '/open-interest-change/:exchange?/:symbol?',
    openInterest: '/open-interest/:exchange?/:symbol?',
    oiOverview: '/oi-overview/:exchange?/:symbol?',
    multiStrikeChart: '/multi-strike-chart/:exchange?/:symbol?',
    seasonals: '/seasonals/:exchange?/:symbol?',
    technicals: '/technicals/:exchange?/:symbol?',
    financials: '/financials/:exchange?/:symbol?',
    components: '/components/:exchange?/:symbol?',
    screener: '/screener/:screenerId?',
    fiiDii: '/fii-dii',
    fiiDiiSummary: '/fii-dii/summary',
    fiiDiiFuturesOptions: '/fii-dii/futures-options',
    fiiDiiCashMarket: '/fii-dii/cash-market',
    fiiDiiFiiHistory: '/fii-dii/fii-history',
    reports: '/reports',
    account: '/account',
    accountPersonal: '/account/personal',
    accountActiveSessions: '/account/active-sessions',
    accountBank: '/account/bank',
    accountNominee: '/account/nominee',
    accountDemat: '/account/demat',
    accountSegments: '/account/segments',
    accountFunds: '/account/funds',
    accountPracticeTrade: '/account/practice-trade',
    profile: '/profile',
    login: '/login',
    authStatus: '/auth/status',
    admin: '/admin',
    cache: '/admin/cache',
    globalNotification: '/admin/global-notification',
    watchList: '/admin/watchList',
    mixpanel: '/admin/mixpanel',
    communityScreens: '/admin/community-screens',
    adminTradingAccounts: '/admin/trading-accounts',
    adminDematApplications: '/admin/demat-applications',
    adminCorporateActions: '/admin/corporate-actions',
    adminUserFeatures: '/admin/user-features',
    adminSupport: '/admin/support',
    signup: '/signup',
    oauthRedirect: '/oauth/redirect',
    googleRedirect: '/oauth/redirect/google',
    xRedirect: '/oauth/redirect/x',
    zerodhaRedirect: '/oauth/redirect/zerodha',
    upstoxRedirect: '/oauth/redirect/upstox',
    angelOneRedirect: '/oauth/redirect/angelone',
    fyresRedirect: '/oauth/redirect/fyres',
    dashboard: '/dashboard',
    userStatus: '/userstatus',
    blocked: '/userstatus/revoked',
    waitlist: '/userstatus/waitlist',
    upstoxOrdersPostback: 'postback/upstox',
    lightweightCharts: '/lightweight-charts',
    automation: '/automation/:exchange?/:symbol?',
    simulator: '/simulator/:exchange?/:symbol?',
    tradingAccount: '/trading-account',
    tradingAccountConnect: '/trading-account/:broker',
    scalper: '/scalper',
    embeddedHome: '/embedded-home',
    embeddedChart: '/embedded-chart',
    embeddedStrategyChart: '/embedded-strategyChart',
    embeddedScalper: '/embedded-scalper',
    screenerExplore: '/screener/explore',
    embeddedPayoff: '/embedded-payoff/:exchange?/:symbol?',
    embeddedMultistrike: '/embedded-multistrike/:exchange?/:symbol?',
    shareholderHoldings: '/shareholders',
    heatmap: '/heatmap',
    industries: '/industries',
    industriesLevel: '/industries/*',
}

export default ROUTES

export const UNPROTECTED_ROUTES = [ROUTES.login, ROUTES.oauthRedirect, ROUTES.authStatus]
export const O_AUTH_ROUTES = [
    ROUTES.oauthRedirect,
    ROUTES.googleRedirect,
    ROUTES.xRedirect,
    ROUTES.zerodhaRedirect,
    ROUTES.upstoxRedirect,
    ROUTES.angelOneRedirect,
    ROUTES.fyresRedirect
]

export const ADMIN_ROUTES = [ROUTES.admin, ROUTES.cache, ROUTES.globalNotification, ROUTES.mixpanel]